import React, { useContext, useReducer, useState, useEffect } from 'react'
import { types } from '../../types/types';

import { AuthContext } from '../../auth/AuthContext'
import { PanelDeControlContext } from '../../context/PanelDeControlContext';
import eventosReducer from '../../reducers/eventosReducer';

import PanelEventos from './panelDeControl/PanelEventos';
import PanelDeInformacion from './panelDeControl/PanelDeInformacion';

import apiAsistentes from '../../services/apis/apiAsistentes';
import apiEventos from '../../services/apis/apiEventos';

import style from '../../assets/styles/panelDeControl.module.css'

const PanelDeControlScreen = () => {

    const { user } = useContext( AuthContext );

    const [ resumen, setResumen ] = useState( null );
    const [ eventos, dispatchEventos ] = useReducer( eventosReducer, null );
    const [ eventoSeleccionado, setEventoSeleccionado ] = useState( null );

    useEffect(() => {

        apiAsistentes.getResumen()
            .then( (response) => {
                if( response.error ) { return }
                setResumen( response.data )
            })


        apiEventos.getAll()
            .then( (response) => {
                if (response.error) {
                    return console.log(response.error.response)
                }
                dispatchEventos({ type: types.eventosCargados, payload: response.response.data.eventos });
            })

    }, [user]);

    return (
    <div className={ style.panelDeControlScreen } >

        <PanelDeControlContext.Provider value={{ eventos, dispatchEventos, eventoSeleccionado, setEventoSeleccionado }}>

            <h1>Bienvenido {user.nombre} </h1>
            <p> Este es tu panel de control. Aquí podrás subir y editar eventos; subir una lista de asistentes para recibir constancias y editarlos. </p>
            <p>Total de personas que han asistido a tus eventos: { resumen?.total } </p>
            <p>Total de personas diferentes: { resumen?.unicos } </p>

            <div className={ style.row }>
                <div className={ style.col5 }>
                    <PanelEventos />
                </div>
                <div className={ style.col7 }>
                    <h2>Información</h2>
                    <PanelDeInformacion />                            
                </div>
            </div>

        </PanelDeControlContext.Provider>


    </div>)
}

export default PanelDeControlScreen
